import { Injectable, inject } from '@angular/core';
import { TeamWorkloadState } from '../../states/team-workload.state';
import { GetTeamWorkloadStateResult } from './get-team-workload-state.result';

@Injectable({ providedIn: 'root' })
export class GetTeamWorkloadStateUseCase {
  private readonly _state = inject(TeamWorkloadState);

  public execute(): GetTeamWorkloadStateResult {
    return {
      summary: this._state.summary,
      overCapacityMembers: this._state.overCapacityMembers,
      overdueMembers: this._state.overdueMembers,
      atRiskMembers: this._state.atRiskMembers,
      timeOffMembers: this._state.timeOffMembers,
      teamWorkloads: this._state.teamWorkloads,
      rebalancingProposals: this._state.rebalancingProposals,
      viewMode: this._state.viewMode,
      includeClosedInvestigations: this._state.includeClosedInvestigations,
      loadingWorkloadOverview: this._state.loadingWorkloadOverview,
      loadingRebalancing: this._state.loadingRebalancing,
      error: this._state.error,
      teamBalancingCandidates: this._state.teamBalancingCandidates,
      loadingTeamBalancingCandidates: this._state.loadingTeamBalancingCandidates,
      proposalGroups: this._state.proposalGroups,
      removedProposalIds: this._state.removedProposalIds,
      proposalOverrides: this._state.proposalOverrides,
      collapsedProposalTeams: this._state.collapsedProposalTeams,
      dismissedProposalIds: this._state.dismissedProposalIds,
      applyingProposals: this._state.applyingProposals,
      effectiveProposals: this._state.effectiveProposals,
    };
  }
}
